export const GET_COMPLAIN_CATEGORIES = 'GET_COMPLAIN_CATEGORIES';
export const GET_COMPLAIN_CATEGORIES_SUCCESS = 'GET_COMPLAIN_CATEGORIES_SUCCESS';
export const UPDATE_COMPLAIN_CATEGORIES_SUCCESS = 'UPDATE_COMPLAIN_CATEGORIES_SUCCESS';
export const ADD_COMPLAIN_CATEGORIES_SUCCESS = 'ADD_COMPLAIN_CATEGORIES_SUCCESS';
export const DELETE_COMPLAIN_CATEGORIES_SUCCESS = 'DELETE_COMPLAIN_CATEGORIES_SUCCESS';
export const SET_FETCHING_CATEGORIES = 'SET_FETCHING_CATEGORIES'